import axios from "axios";
import { VENDORID } from "../constants";
import { CONFIG } from "../config";

//get setting
 export async function getSettingJSONRequest(settingModuleNr, settingCode) {
    var request = await axios.post(CONFIG.URL, {
      serviceId: '5250',
      vendorId: VENDORID,
      token: sessionStorage.getItem('token'),
      settingModuleNr: settingModuleNr,
      settingCode: settingCode,
    });
    return request.data;
  }